module.exports = __webpack_public_path__ + "static/media/avatar.a365f0e1.png";